import createIcon from '../../createIcon';

/**
 * @component @name Directions
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNDExMSAxMC41ODVMMTMuNDIxMSAyLjU4NUMxMi42NDExIDEuODA1IDExLjM3MTEgMS44MDUgMTAuNTkxMSAyLjU4NUwyLjU4MTA5IDEwLjU4NUMxLjgwMTA5IDExLjM2NSAxLjgwMTA5IDEyLjYzNSAyLjU4MTA5IDEzLjQxNUwxMC41OTExIDIxLjQxNUMxMS4zNzExIDIyLjE5NSAxMi42NDExIDIyLjE5NSAxMy40MjExIDIxLjQxNUwyMS40MTExIDEzLjQxNUMyMi4yMDExIDEyLjYyNSAyMi4yMDExIDExLjM2NSAyMS40MTExIDEwLjU4NVpNMTMuNTAxMSAxNC40OTVWMTEuOTk1SDEwLjAwMTFWMTQuOTk1SDguMDAxMDlWMTAuOTk1QzguMDAxMDkgMTAuNDQ1IDguNDUxMDkgOS45OTUgOS4wMDEwOSA5Ljk5NUgxMy41MDExVjcuNDk1TDE3LjAwMTEgMTAuOTk1TDEzLjUwMTEgMTQuNDk1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Directions = createIcon('Directions', [
  [
    'path',
    {
      d: 'M21.4111 10.585L13.4211 2.585C12.6411 1.805 11.3711 1.805 10.5911 2.585L2.58109 10.585C1.80109 11.365 1.80109 12.635 2.58109 13.415L10.5911 21.415C11.3711 22.195 12.6411 22.195 13.4211 21.415L21.4111 13.415C22.2011 12.625 22.2011 11.365 21.4111 10.585ZM13.5011 14.495V11.995H10.0011V14.995H8.00109V10.995C8.00109 10.445 8.45109 9.995 9.00109 9.995H13.5011V7.495L17.0011 10.995L13.5011 14.495Z',
      key: '156nug',
    },
  ],
]);

export default Directions;
